import { MouseClickIcon } from '#components/mouse-interaction-icon/mouse-click-icon.js';

/**
 * Tooltip body teaching the two ways to interact with a design-reference chip: left-click to
 * view the referenced element in the renderer, right-click to open its info pane.
 *
 * @returns The hint rows with mouse-button icons.
 */
export function ChipInteractionHintTooltipContent() {
	return (
		<div className='flex flex-col gap-2 text-sm'>
			<div className='flex items-center gap-1'>
				<MouseClickIcon side='left' className='-m-1 text-lg' />
				<span>Zoom to this in renderer</span>
			</div>
			<div className='flex items-center gap-1'>
				<MouseClickIcon side='right' className='-m-1 text-lg' />
				<span>Open info pane</span>
			</div>
		</div>
	);
}
